import api from '../api'
export default {
    namespaced: true,
    state: {
        warnList:{// 报警
            beanList:[],
            total:0
        },
        exceptionList:{// 异常
            beanList:[],
            total:0
        }
    },
    mutations: {
        setStateWarnList(state,info){
            state.warnList = info
        },
        setStateExceptionList(state,info){
            state.exceptionList = info
        }
    },
    actions: {
        getWarnList({commit},params){
            return api.post('/audit/warn/list','报警列表',params).then(res=>{
                commit('setStateWarnList',res.data)
            })
        },
        updateWarnRecord(store,params){
            return api.post('/audit/record/dispose','处理报警记录',params)
        },
        getExceptionList({commit},params){
            return api.post('/audit/exception/list','操作行为审计异常记录',params).then(res=>{
                commit('setStateExceptionList',res.data)
            })
        },
        updateExceptionRecord(store,params){
            return api.post('/audit/exception/dispose','处理操作行为审计异常记录',params)
        }
    }
}